module.exports = __webpack_public_path__ + "static/image@3x-b1372d57a1b296d467fbb9403b9d4ebc.png";